import angular from 'angular'
import moment from 'moment'
import templateUrl from "./rogers-recruiting-bonus-report.component.html";
import { containsInvariant } from '../../../core/services/filter-util';

export const RogersRecruitingBonusReportComponent = {
    templateUrl,
    bindings: {
        recruitingBonusReport: "<"
    },
    controller: class {
        constructor() {
            'ngInject'
            this.pageNumber = 1;
            this.pageSize = 10;
            this.filters = {};
        }

        $onInit() {
        }

        $onChanges(changes) {
            if (changes.recruitingBonusReport && changes.recruitingBonusReport.currentValue) {
                this.filteredReport = changes.recruitingBonusReport.currentValue.filter(p => this.filterReport(p));
            }
        }

        onChangeFilter() {
            this.pageNumber = 1;
            this.filteredReport = angular.copy(this.recruitingBonusReport);
            this.filteredReport = this.recruitingBonusReport.filter(p => this.filterReport(p));
        }

        filterReport(data) {

            return (!this.filters.Owner || containsInvariant(data.Owner, this.filters.Owner))
                && (!this.filters.ClientName || containsInvariant(data.ClientName, this.filters.ClientName))
                && (!this.filters.RepName || containsInvariant(data.RepName, this.filters.RepName))
                && (!this.filters.CurrentStatus || containsInvariant(data.CurrentStatus, this.filters.CurrentStatus))
                && (!this.filters.CumulativeEligableConfirmed || containsInvariant(data.CumulativeEligableConfirmed,
                    this.filters.CumulativeEligableConfirmed))
                && (!this.filters.Status || containsInvariant(data.Status, this.filters.Status))
                && (!this.filters.BookedDate || moment(this.filters.BookedDate).isSame(data.BookedDate, "day"))
                && (!this.filters.InstalledDate || moment(this.filters.InstalledDate).isSame(data.InstalledDate, "day"))
                && (!this.filters.OnboardingApprovalDate || moment(this.filters.OnboardingApprovalDate).isSame(data.OnboardingApprovalDate, "day"))
                && (!this.filters.CurrentStatusDate || moment(this.filters.CurrentStatusDate).isSame(data.CurrentStatusDate, "day"))
                && (!this.filters.BookedDate || moment(this.filters.BookedDeadLine).isSame(data.BookedDeadLine, "day"))
                && (!this.filters.StatusDate || moment(this.filters.InstalledDeadLine).isSame(data.InstalledDeadLine, "day"));
        }

    }
}

